import { Router } from '@angular/router';
import { TenantNotification } from '../../../../../../backend-core-lib/app/common-shared/account/models';
import { getCurrentDateLinuxMs } from '../../../../../../backend-core-lib/app/common-shared/utils/get-current-date-linux-ms';
import { getUrlWithoutQueryParams } from '../../../../common-shared/utils/browser/get-url-without-query-params';
import { getQueryParamsFromUrl } from '../../../../common-shared/utils/browser/get-query-params-from-url';

export async function navigateToNotificationAction(
  tenantNotification: TenantNotification,
  router: Router,
) {
  if (tenantNotification.actionUrl) {
    const routeUrl = getUrlWithoutQueryParams(tenantNotification.actionUrl);
    const queryParams = getQueryParamsFromUrl(tenantNotification.actionUrl);
    tenantNotification.seenAt = getCurrentDateLinuxMs();
    await router.navigate(
      [routeUrl],
      queryParams
        ? {
            queryParams: queryParams,
          }
        : undefined,
    );
  }
}
